import React from "react";

const DEFAULT_SIZE = 64;

const OrbitalLoader = ({ size = DEFAULT_SIZE, special = false, text = null, className = "" }) => {
  const parsedSize = Number(size);
  const iconSize = Number.isFinite(parsedSize) && parsedSize > 0 ? parsedSize : DEFAULT_SIZE;
  const tone = special ? "var(--theme-primary)" : "var(--theme-secondary-text)";

  return (
    <>
    <style>{`@keyframes orbitalFadeIn { from { opacity: 0; } to { opacity: 0.5; } }`}</style>
    <span
      role="status"
      aria-live="polite"
      aria-label={text || "Loading"}
      className={`flex flex-col items-center justify-center text-center ${className}`.trim()}
      style={{
        color: tone,
        animation: "orbitalFadeIn 0.5s ease-out 0.5s both",
      }}
    >
      <svg
        width={iconSize}
        height={iconSize}
        viewBox="0 0 120 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <circle cx="60" cy="60" r="15" fill="currentColor" fillOpacity={special ? 0.2 : 0.14} />
        <circle cx="60" cy="60" r="9" fill="currentColor" fillOpacity={special ? 0.9 : 0.55} />

        <circle cx="60" cy="60" r="22" stroke="currentColor" strokeWidth="2.25" strokeOpacity={special ? 0.4 : 0.3} />
        <g>
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 60 60"
            to="360 60 60"
            dur="2.8s"
            repeatCount="indefinite"
          />
          <circle cx="82" cy="60" r="4.2" fill="currentColor" fillOpacity={special ? 0.92 : 0.72} />
        </g>

        <g transform="rotate(55 60 60)">
          <ellipse cx="60" cy="60" rx="35" ry="16" stroke="currentColor" strokeWidth="2" strokeOpacity={special ? 0.34 : 0.24} />
          <g>
            <animateTransform
              attributeName="transform"
              type="rotate"
              from="360 60 60"
              to="0 60 60"
              dur="4.2s"
              repeatCount="indefinite"
            />
            <circle cx="95" cy="60" r="3.4" fill="currentColor" fillOpacity={special ? 0.85 : 0.62} />
          </g>
        </g>

        <g transform="rotate(-28 60 60)">
          <ellipse cx="60" cy="60" rx="46" ry="19" stroke="currentColor" strokeWidth="1.8" strokeOpacity={special ? 0.28 : 0.2} />
          <g>
            <animateTransform
              attributeName="transform"
              type="rotate"
              from="0 60 60"
              to="360 60 60"
              dur="5.5s"
              repeatCount="indefinite"
            />
            <circle cx="106" cy="60" r="2.8" fill="currentColor" fillOpacity={special ? 0.78 : 0.54} />
          </g>
        </g>

        <circle cx="28" cy="26" r="1.6" fill="currentColor" fillOpacity={special ? 0.55 : 0.35}>
          <animate attributeName="opacity" values="0.2;0.7;0.2" dur="1.8s" repeatCount="indefinite" />
        </circle>
        <circle cx="92" cy="20" r="1.2" fill="currentColor" fillOpacity={special ? 0.5 : 0.3}>
          <animate attributeName="opacity" values="0.1;0.6;0.1" dur="2.3s" repeatCount="indefinite" />
        </circle>
      </svg>

      {text ? (
        <span className={`mt-3 text-sm ${special ? "text-theme-primary" : "text-theme-text opacity-70"}`}>
          {text}
        </span>
      ) : null}
    </span>
    </>
  );
};

export default OrbitalLoader;
